import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';
import './SeccionContacto.css';

const ICONO_TEL = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const ICONO_EMAIL = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const ICONO_WHATSAPP = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const ICONO_UBICACION = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ICONO_RELOJ = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const TARJETAS = [
  { id: 'tel', icono: ICONO_TEL, texto: 'Tel: (0220) 4802969' },
  { id: 'email', icono: ICONO_EMAIL, texto: 'acostahnos@yahoo.com.ar', esEnlace: true, href: 'mailto:acostahnos@yahoo.com.ar' },
  { id: 'whatsapp', icono: ICONO_WHATSAPP, texto: 'WhatsApp: 11-5383-7427' },
  { id: 'ubicacion', icono: ICONO_UBICACION, texto: 'Lautaro 868, Merlo-Buenos Aires' },
  { id: 'horarios', icono: ICONO_RELOJ, texto: 'Lun. a Vie.: 8:00 a 17:00 hs' },
];

function SeccionContacto() {
  return (
    <section id="contacto" className="seccion-contacto" aria-labelledby="seccion-contacto-titulo">
      <h2 id="seccion-contacto-titulo" className="seccion-contacto__titulo">
        Contacto
      </h2>
      <div className="seccion-contacto__grid">
        {TARJETAS.map((item, i) => (
          <AnimateOnScroll
            key={item.id}
            className={`seccion-contacto__tarjeta${item.id === 'horarios' ? ' seccion-contacto__tarjeta--horarios' : ''}`}
            delay={i * 80}
          >
            <div className="seccion-contacto__icono" aria-hidden="true">
              {item.icono}
            </div>
            {item.esEnlace ? (
              <a href={item.href} className="seccion-contacto__texto seccion-contacto__texto--link">
                {item.texto}
              </a>
            ) : (
              <span className="seccion-contacto__texto">{item.texto}</span>
            )}
          </AnimateOnScroll>
        ))}
      </div>
    </section>
  );
}

export default SeccionContacto;
